
export default function Process() {
  const steps = [
    {
      number: '01',
      title: 'Discover',
      description: 'We analyze your current workflows and identify automation opportunities that will deliver the biggest impact.',
      icon: 'ri-search-line'
    },
    {
      number: '02',
      title: 'Proposal',
      description: 'Receive a detailed automation roadmap with clear timelines, costs, and expected ROI for each solution.',
      icon: 'ri-file-text-line'
    },
    {
      number: '03',
      title: 'Design',
      description: 'We map out intelligent workflows and design AI integrations that seamlessly fit your existing systems.',
      icon: 'ri-draft-line'
    },
    {
      number: '04',
      title: 'Build',
      description: 'Our team develops and configures your automation solutions using cutting-edge AI and integration technologies.',
      icon: 'ri-code-box-line'
    },
    {
      number: '05',
      title: 'Test',
      description: 'Rigorous testing ensures your automations work flawlessly and handle edge cases before going live.',
      icon: 'ri-bug-line'
    },
    {
      number: '06',
      title: 'Launch',
      description: 'We deploy your automation solutions and provide training to ensure your team maximizes the benefits.',
      icon: 'ri-rocket-line'
    }
  ];

  return (
    <section className="py-24 px-6 bg-gradient-to-b from-white to-[#EBEBE0]">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-bold text-[#182114] mb-6" style={{ fontFamily: '"Distro Bold", sans-serif' }}>
            How We <span className="text-[#AFC4E4]">Automate</span>
          </h2>
          <div className="w-24 h-1 bg-[#AFC4E4] mx-auto mb-8"></div>
          <p className="text-xl text-[#2E3F25] max-w-3xl mx-auto" style={{ fontFamily: '"Century Gothic", sans-serif' }}>
            Our proven process ensures your automation solutions deliver real results from day one.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {steps.map((step, index) => (
            <div
              key={index}
              className="group bg-white p-8 rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-500 hover:-translate-y-2"
            >
              <div className="flex items-center gap-4 mb-6">
                <div 
                  className="w-16 h-16 bg-gradient-to-br from-[#AFC4E4] to-[#9BB5D9] rounded-2xl flex items-center justify-center group-hover:scale-110 group-hover:rotate-3 transition-all duration-300"
                >
                  <i className={`${step.icon} text-3xl text-white`}></i>
                </div>
                <span className="text-4xl font-bold text-[#AFC4E4]" style={{ fontFamily: '"Distro Bold", sans-serif' }}>
                  {step.number}
                </span>
              </div>
              
              <h3 className="text-2xl font-bold text-[#182114] mb-4" style={{ fontFamily: '"Distro Bold", sans-serif' }}>
                {step.title}
              </h3>
              
              <p className="text-[#2E3F25] leading-relaxed" style={{ fontFamily: '"Century Gothic", sans-serif' }}>
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
